export enum SsoAuthenticationSessionStorageKey {
    IDP_TOKEN = 'IDP_TOKEN', // should be deprecated in the future
    IDP_CODE = 'IDP_CODE',
    STATE_CLAIM = 'STATE_CLAIM',
    CODE_VERIFIER = 'CODE_VERIFIER',
    URL_BEFORE_IDP_REDIRECTION = 'URL_BEFORE_IDP_REDIRECTION'
}
